
import React from 'react';
import { LayoutGrid, List } from 'lucide-react';
import { Toggle } from '@/components/ui/toggle';
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group';

interface GridToggleProps {
  layout: 'grid' | 'list';
  onChange: (layout: 'grid' | 'list') => void;
  className?: string;
}

const GridToggle: React.FC<GridToggleProps> = ({ layout, onChange, className }) => {
  return (
    <ToggleGroup 
      type="single" 
      value={layout} 
      onValueChange={(value) => value && onChange(value as 'grid' | 'list')}
      className={className}
    >
      <ToggleGroupItem value="list" aria-label="List view">
        <List size={16} />
      </ToggleGroupItem>
      <ToggleGroupItem value="grid" aria-label="Grid view">
        <LayoutGrid size={16} />
      </ToggleGroupItem>
    </ToggleGroup>
  );
};

export default GridToggle;
